import angular from 'angular';

const modalMovableDirective = /* @ngInject */ (/** @type {import('angular').IDocumentService} */ $document) => ({
	restrict: 'A',
	link:     (/** @type {any} */ scope, /** @type {import('angular').IRootElementService} */ element) => {
		let startX = 0;
		let startY = 0;
		let x = 0;
		let y = 0;

		const dialogWrapper = element.closest('.modal-dialog');

		const mousemove = (/** @type {MouseEvent} */ event) => {
			y = event.pageY - startY;
			x = event.pageX - startX;
			dialogWrapper.css({
				top:  `${y}px`,
				left: `${x}px`,
			});
		};

		const mouseup = () => {
			dialogWrapper.removeClass('modal-grabbing');
			// @ts-ignore
			$document.unbind('mousemove', mousemove);
			$document.unbind('mouseup', mouseup);
		};

		dialogWrapper.css({
			position: 'relative',
		});

		// @ts-ignore
		element.on('mousedown', (/** @type {MouseEvent} */ event) => {
			dialogWrapper.addClass('modal-grabbing');
			// Prevent default dragging of selected content
			event.preventDefault();
			startX = event.pageX - x;
			startY = event.pageY - y;
			// @ts-ignore
			$document.on('mousemove', mousemove);
			$document.on('mouseup', mouseup);
		});
	},
});

angular.module('app')
	.directive('modalMovable', modalMovableDirective);
